<template>
  <div class="grid">
    <slot></slot>
  </div>
</template>

<!--suppress JSValidateTypes, JSCheckFunctionSignatures -->
<script>
  import { Graphics } from 'pixi.js-legacy'

  export default {
    name: "grid",
    props: [
      'lines', // Vertical Grid lines
    ],
    data() {
      return {
        instance: new Graphics(),
      }
    },
    inject: [
      'convertToPixels',
      'addToPanel',
      'textLabels',
    ],
    methods: {
      render() {
        let parent = this.$parent
        let labels = this.textLabels.map(label => label.x)

        // Grid lines
        for (let line of this.lines.map(u => this.convertToPixels(u))) {
          // How many parts of 30 the line should be long
          let lineLength = labels.includes(line) ? 16 : 12
          let lineStart = 4
          this.instance.beginFill(0xCCCCCC)
          this.instance.drawRect(
            line, parent.height/30 * lineStart + 10,
            1,    parent.height/30 * lineLength
          )
          this.instance.endFill()
        }
        // The grid lines should be behind the markers (indicators)
        // but on top of the shading (which has zIndex 2)
        this.instance.zIndex = 4
        this.instance.name = 'Grid'
      },
      reRender() {
        this.instance.clear()
        this.render()
      },
    },
    watch: {
      lines() {
        this.reRender()
      },
    },
    created() {
      this.render()
      this.addToPanel(this.instance)
    },
    beforeDestroy() {
      this.instance.parent.removeChild(this.instance)
      this.instance.destroy({children: true})
    }
  }
</script>

<style scoped>

</style>